/**
 * Pay-before checkout creates the booking (and closes the proposal) before the
 * Dintero session is ready. While that gap is open, getBookingProposalBySlug
 * 410s and BookingProposalWrapper would paint the "already booked" screen.
 * This flag keeps that wrapper on a loader until navigation to payment finishes.
 */
// Module flag (not React state): read during proposal-wrapper render across the
// create-booking → payment-session gap. Reassignment is the point of the API.
// eslint-disable-next-line no-restricted-syntax -- intentional mutable checkout gate
let payBeforeCheckoutInFlight = false;

export function setProposalPayBeforeCheckoutInFlight(value: boolean): void {
  payBeforeCheckoutInFlight = value;
}

export function isProposalPayBeforeCheckoutInFlight(): boolean {
  return payBeforeCheckoutInFlight;
}
